// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails');

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log(
  'Visit the guide for more information: ',
  'https://vite-ruby.netlify.app/guide/rails'
);

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

import '../theme/appstack-4.0/js/app.js';
import '../theme/appstack-4.0/css/app.css';

// Import SVG Generator (conditionally loaded based on page)
const currentPath = window.location.pathname;
if (currentPath.includes('/svg_generator') || 
    (currentPath.includes('/site_map_svgs/') && currentPath.includes('/edit'))) {
  import('./svg_generator.js').then(module => {
    // Ensure the module is fully loaded before DOM ready
    console.log('SVG Generator loaded');
  });
  import('./svg_generator.css');
}
